import React, {Component} from 'react';
import MUIDataTable from "mui-datatables";
import {queryParams} from "../../../utils/utils";
import PropTypes from "prop-types";
import {Button, Tooltip} from "@material-ui/core";
import moment from "moment";
import ConsoleActionStatus from "../../SystemLog/ConsoleActionStatus";
import {search} from "../../../redux/groundTeamEventLog/groundTeamEventLog.action";
import {connect} from "react-redux";
import {withAuth0} from "@auth0/auth0-react";
import CustomToolbar from '../../../components/List/CustomToolBar/CustomToolbar';

const datetime_format = process.env.REACT_APP_DATETIME_FORMAT;

class GroundTeamEventLogList extends Component {
  constructor(props) {
    super(props);
    this.isFilterDialogOpen = false;
    this.tableRef = React.createRef();
    this.columnsDisplay = undefined;
  }

  static propTypes = {
    filters: PropTypes.array,
  };

  componentDidMount() {
    this.refresh();
  }

  refresh = () => {
    const {search, filters, uuid} = this.props;

    // table state
    const state = this.tableRef?.current?.state;

    const params = queryParams(this.props, state);

    filters?.map((f) => params.set(f.key, f.value));

    if (uuid !== null && uuid !== undefined) {
      params.set("groundTeamUserUuid", uuid);
    }

    search(params);
  };

  onChangeColumnDisplay = () => {
    const state = this.tableRef?.current?.state;
    this.columnsDisplay = state.columns.reduce(
      (obj, item) => Object.assign(obj, {[item.name]: item.display}),
      {}
    );
  };

  isDisplay = (name) => {
    if (!this.columnsDisplay || !this.columnsDisplay.hasOwnProperty(name))
      return undefined;
    else return this.columnsDisplay[name];
  };

  render() {
    const {groundTeamEventLogs} = this.props;
    if (!groundTeamEventLogs) return <React.Fragment>Loading...</React.Fragment>;
    const list = groundTeamEventLogs?.content;
    const totalElements = groundTeamEventLogs?.totalElements ?? 0;
    const rowsPerPage = groundTeamEventLogs?.pageable?.pageSize ?? 10;
    const page = groundTeamEventLogs?.pageable?.pageNumber ?? 0;

    const columns = [
      {
        name: "createdAt",
        label: "Action Time",
        options: {
          filter: false,
          sort: false,
          display: this.isDisplay("createdAt") ?? true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (
              <Tooltip title={value ? moment.utc(value).local().format(datetime_format) : ""}>
                <div>{value ? moment.utc(value).local().format(datetime_format) : ""}</div>
              </Tooltip>
            );
          },
        },
      },
      {
        name: "eventType",
        label: "Action Object",
        options: {
          filter: true,
          sort: false,
          display: this.isDisplay("eventType") ?? true,
          customFilterListOptions: {render: (v) => `eventType: ${v}`},
        },
      },
      {
        name: "event",
        label: "Type",
        options: {
          filter: true,
          sort: false,
          display: this.isDisplay("event") ?? true,
          customFilterListOptions: {render: (v) => `event: ${v}`},
        },
      },
      {
        name: "vehicleUuid",
        label: "Related Vehicle",
        options: {
          filter: false,
          sort: false,
          display: this.isDisplay("vehicleUuid") ?? true,
          customFilterListOptions: {render: (v) => `vehicleUuid: ${v}`},
        },
      },
      {
        name: "actionContent",
        label: "Operation Content",
        options: {
          filter: false,
          sort: false,
          display: this.isDisplay("actionContent") ?? true
        },
      },
      {
        name: "responseStatus",
        label: "Action Status",
        options: {
          filter: false,
          sort: false,
          display: this.isDisplay("actionContent") ?? true,
          customBodyRender: (value, tableMeta, updateValue) => {
            return (<ConsoleActionStatus status={value}/>);
          },
        },
      },
      {
        name: "createdBy",
        label: "Executor",
        options: {
          filter: false,
          sort: false,
          display: this.isDisplay("createdBy") ?? true,
          customBodyRender: (value, tableMeta) =>
            tableMeta?.tableData[tableMeta["rowIndex"]]["createdByUserName"]
        }
      },
    ];

    const options = {
      search: false,
      viewColumns: false,
      filter: true,
      confirmFilters: true,
      serverSide: true,
      filterType: "dropdown",
      responsive: "vertical",
      rowsPerPageOptions: [10, 20, 50, 100],
      rowsPerPage: rowsPerPage,
      count: totalElements,
      page: page,
      customToolbarSelect: () => {
      },
      onTableChange: (action) => {
        switch (action) {
          case "viewColumnsChange":
            this.onChangeColumnDisplay();
            break;
          case "onFilterDialogOpen":
            this.isFilterDialogOpen = true;
            break;
          case "filterChange":
            if (this.isFilterDialogOpen) return;
            else this.refresh();
            break;
          case "onFilterDialogClose":
            this.isFilterDialogOpen = false;
          case "changePage":
          case "sort":
          case "changeRowsPerPage":
            this.refresh();
            break;
          default:
            console.log("Not handled action " + action);
        }
      },
      customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
        return (
          <div style={{marginTop: "40px"}}>
            <Button
              variant="contained"
              style={{color: "white", backgroundColor: "#333399"}}
              onClick={() => {
                applyNewFilters();
              }}
            >
              Apply
            </Button>
          </div>
        );
      },
      customToolbar: () => {
        return (
          <CustomToolbar refresh={this.refresh} tableProps={this.props}/>
        );
      }
    };


    return (
      <React.Fragment>
        <MUIDataTable
          title={"Ground Team Action Logs"}
          data={list}
          columns={columns}
          options={options}
          ref={this.tableRef}
        />
      </React.Fragment>
    );
  }
};

const mapStateToProps = (state) => ({
  groundTeamEventLogs: state.groundTeamEventLogReducer.groundTeamEventLogs,
});

const mapDispatchToProps = (dispatch) => ({
  search: (params) => dispatch(search(params)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAuth0(GroundTeamEventLogList));